import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

export const DIALOG_TYPE = 'remove-deposit-request';

@Component({
  selector: 'app-remove-deposit-request-dialog',
  templateUrl: './remove-deposit-request-dialog.component.html',
  styleUrls: ['./remove-deposit-request-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveDepositRequestDialogComponent implements OnInit {
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() documentType: DocumentTypesEnum;

  @Output()
  onRemoveDepositRequest: EventEmitter<void> = new EventEmitter<void>();

  dialogType: string;
  trackingObject: ITrackingObject;
  primaryActionTapped: ITrackingAction;
  secondaryActionTapped: ITrackingAction;

  constructor(
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.trackingObject = this._trackingObjectBuilder.buildDialog(
      TrackingDialogNamesEnum.deposit_enable_payments_again
    );
    this.primaryActionTapped = this._trackingActionBuilder.buildButtonTapped(
      'yes',
      this.trackingScreenName
    );
    this.secondaryActionTapped = this._trackingActionBuilder.buildButtonTapped(
      'no',
      this.trackingScreenName
    );
  }
}
